import {
  Stack,
  HStack,
  Avatar,
  Heading,
  Text,
  useColorModeValue,
  Spinner,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { ListChatInterface } from "../constants/Chat";
import useCustomToast from "../lib/useCustomToast";
import { useGetUserLoginStore } from "../store/useGetUserLoginStore";
import { getAxiosInstance } from "../utils/helperFunction";
import { Empty } from "./card/Empty";
import SearchInput from "./input/SearchInput";
import { useBgBaseColor } from "../themes/colors";

interface MobileListChatProps {
  onSelectedChat: (selected: string | undefined) => void;
}

const MobileListChat = ({ onSelectedChat }: MobileListChatProps) => {
  const [data, setData] = useState<ListChatInterface[] | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const { currentActiveUser: user } = useGetUserLoginStore();
  const bgBase = useBgBaseColor();
  const bgHoverCard = useColorModeValue("gray.100", "gray.700");
  const toast = useCustomToast();

  const [search, setSearch] = useState("");
  const [filteredChatList, setFilteredChatList] = useState(data);

  const whiteColor = useColorModeValue("white", "whiteAlpha.100");

  useEffect(() => {
    setFilteredChatList(
      data?.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, data]);

  useEffect(() => {
    let pageType = 1; //buyer

    if (user) {
      if (user?.role === "supplier") {
        pageType = 3;
      }

      const axiosInstance = getAxiosInstance(pageType);
      axiosInstance
        .get(`/v1/chat/list-${user?.role}-chat/${user?.id}?search=`)
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => {
          toast({
            description: err.response.data.message,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [user]);

  return (
    <Stack
      spacing={4}
      padding={4}
      width="100%"
      height="100%"
      backgroundColor={bgBase}
    >
      <SearchInput
        placeholder={getPlaceholder(user?.role || "")}
        _placeholder={{ fontSize: "md" }}
        paddingY={7}
        paddingLeft={12}
        paddingRight={6}
        groupPaddingX={6}
        fontSize="md"
        boxSize="20px"
        backgroundColor={whiteColor}
        border="none"
        borderRadius="xl"
        onConfirm={(searchQuery) => {
          setSearch(searchQuery);
        }}
      />
      {loading && (
        <Spinner size="lg" color="red.500" alignSelf="center" marginTop={8} />
      )}
      {filteredChatList?.length === 0 && (
        <Empty
          title="Mulai Berinteraksi"
          subtitle="Cari produk yang ingin anda tanyakan"
          width="100%"
          paddingY={8}
        />
      )}
      {filteredChatList?.map((item) => (
        <Stack key={item?.id_chat}>
          <HStack
            width="100%"
            paddingX={6}
            paddingY={4}
            backgroundColor={whiteColor}
            borderRadius="xl"
            cursor="pointer"
            _hover={{ bg: bgHoverCard }}
            onClick={() => onSelectedChat(item?.id_chat)}
          >
            <Avatar
              name={item?.name}
              src={`${process.env.REACT_APP_MEDIA_URL}${item?.avatar}`}
              size={"md"}
            />
            <Stack spacing={0} width="100%">
              <Heading fontSize="md">{item?.name}</Heading>
              <Text
                fontSize="sm"
                color="gray.500"
                noOfLines={1}
                maxWidth="20ch"
              >
                {item?.message}
              </Text>
            </Stack>
            <Stack height="100%">
              <Text fontSize="xs" color="gray.400">
                {getDateTime(item?.created_at)}
              </Text>
            </Stack>
          </HStack>
        </Stack>
      ))}
    </Stack>
  );
};

export default MobileListChat;

const getDateTime = (date: string | Date) => {
  const dateObj = new Date(date);
  if (new Date().getTime() - dateObj.getTime() < 60000) {
    return "Baru";
  } else if (new Date().getDate() - dateObj.getDate() < 1) {
    return dateObj.toLocaleTimeString("id-ID", {
      hour: "2-digit",
      minute: "2-digit",
    });
  } else if (new Date().getDate() - dateObj.getDate() === 1) {
    return "Kemarin";
  } else if (new Date().getDate() - dateObj.getDate() < 7) {
    return dateObj.toLocaleDateString("id-ID", { weekday: "long" });
  }
  return dateObj.toLocaleDateString("id-ID", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

const getPlaceholder = (role: string) => {
  switch (role) {
    case "buyer":
      return "Cari Toko...";
    case "supplier":
      return "Cari Pelanggan...";
    default:
      return "Cari Pengguna...";
  }
};
